export default [
    {
        key: 'addressbook.list',
        type: 'route',
        route: 'app.contacts.index',
        right: 'addressbook::list',
        children: [
            {
                key: 'addressbook.create',
                type: 'route',
                route: 'app.contacts.create',
                right: 'addressbook::create',
                showInNavigation: false
            },
            {
                key: 'addressbook.details.main',
                type: 'placeholder',
                showInNavigation: false,
                children: [
                    {
                        key: 'addressbook.details.overview',
                        type: 'route',
                        route: 'app.contacts.details.overview',
                        right: 'addressbook::view'
                    },
                    {
                        key: 'addressbook.details.documents',
                        type: 'route',
                        route: 'app.contacts.details.documents',
                        right: 'addressbook::documents'
                    },
                    {
                        key: 'addressbook.details.rsvps',
                        type: 'route',
                        route: 'app.contacts.details.rsvps',
                        right: 'addressbook::rsvps'
                    },
                    {
                        key: 'addressbook.details.messages',
                        type: 'route',
                        route: 'app.contacts.details.messages',
                        right: 'addressbook::messages'
                    },
                    {
                        key: 'addressbook.details.invoices',
                        type: 'route',
                        route: 'app.contacts.details.invoices',
                        right: 'addressbook::invoices'
                    },
                    {
                        key: 'addressbook.details.checkins',
                        type: 'route',
                        route: 'app.contacts.details.checkins',
                        right: 'checkins::list'
                    },
                    {
                        key: 'addressbook.details.changelog',
                        type: 'route',
                        route: 'app.contacts.details.changelog',
                        right: 'addressbook::changelog'
                    },
                    {
                        key: 'addressbook.details.edit',
                        type: 'route',
                        route: 'app.contacts.edit',
                        showInNavigation: false,
                        hideTabNav: true,
                        right: 'addressbook::edit'
                    }
                ]
            }
        ]
    },
    {
        key: 'addressbook.create',
        type: 'route',
        route: 'app.contacts.create',
        right: 'addressbook::create',
        showInNavigation: false,
        hideTabNav: true
    },
    {
        key: 'addressbook.duplicates',
        type: 'route',
        route: 'app.contacts.duplicates',
        right: 'addressbook::duplicates'
    },
    {
        key: 'addressbook.edit-multiple',
        type: 'route',
        route: 'app.contacts.multi-edit',
        right: 'addressbook::edit',
        showInNavigation: false,
        hideTabNav: true
    },
    {
        key: 'addressbook.import',
        type: 'route',
        route: 'app.contacts.import',
        right: 'addressbook::import'
    },
    {
        key: 'addressbook.changelog',
        type: 'route',
        route: 'app.contacts.changelog',
        right: 'addressbook::changelog'
    },
    {
        key: 'addressbook.messages.main',
        type: 'placeholder',
        children: [
            {
                key: 'addressbook.messages.sent-messages',
                type: 'route',
                route: 'app.messages.index',
                right: 'messages::list',
                children: [
                    {
                        key: 'addressbook.messages.message-details',
                        type: 'route',
                        route: 'app.messages.details',
                        showInNavigation: false,
                        hideTabNav: true
                    }
                ]
            },
            {
                key: 'addressbook.messages.templates',
                type: 'route',
                route: 'app.templates.index',
                right: 'templates::list',
                children: [
                    {
                        key: 'addressbook.messages.template-details',
                        type: 'route',
                        route: 'app.templates.details',
                        showInNavigation: false,
                        hideTabNav: true
                    }
                ]
            }
        ]
    },
    {
        key: 'addressbook.sms.main',
        type: 'placeholder',
        children: [
            {
                key: 'addressbook.sms.sent-messages',
                type: 'route',
                route: 'app.messages.sms.index',
                right: 'messages::list-sms',
                children: [
                    {
                        key: 'addressbook.sms.message-details',
                        type: 'route',
                        route: 'app.messages.sms.edit',
                        showInNavigation: false,
                        hideTabNav: true
                    }
                ]
            },
            {
                key: 'addressbook.sms.templates',
                type: 'route',
                route: 'app.messages.sms.templates.index',
                right: 'templates::list',
                children: [
                    {
                        key: 'addressbook.messages.template-create',
                        type: 'route',
                        route: 'app.messages.sms.templates.create',
                        showInNavigation: false,
                        hideTabNav: true
                    },
                    {
                        key: 'addressbook.messages.template-edit',
                        type: 'route',
                        route: 'app.messages.sms.templates.edit',
                        showInNavigation: false,
                        hideTabNav: true
                    }
                ]
            }
        ]
    },
    {
        key: 'addressbook.documents.main',
        type: 'placeholder',
        children: [
            {
                key: 'addressbook.documents.exports.main',
                type: 'route',
                route: 'app.documents.main.index',
                right: 'documents::list',
                children: [
                    {
                        key: 'addressbook.documents.exports.details',
                        type: 'route',
                        route: 'app.documents.main.details',
                        right: 'documents::view',
                        showInNavigation: false,
                    }
                ]
            },
            {
                key: 'addressbook.documents.templates.main',
                type: 'route',
                route: 'app.documents.templates.index',
                right: 'documents::template-list',
                children: [
                    {
                        key: 'addressbook.documents.templates.create',
                        type: 'route',
                        route: 'app.documents.templates.create',
                        right: 'documents::template-create',
                        showInNavigation: false,
                    },
                    {
                        key: 'addressbook.documents.templates.details',
                        type: 'route',
                        route: 'app.documents.templates.details',
                        right: 'documents::template-view',
                        showInNavigation: false,
                        children: [
                            {
                                key: 'addressbook.documents.templates.edit',
                                type: 'route',
                                route: 'app.documents.templates.edit',
                                right: 'documents::template-edit',
                                showInNavigation: false,
                                hideTabNav: true
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        key: 'addressbook.invoices.main',
        type: 'route',
        route: 'app.billing.invoices.index',
        right: 'billing::invoice-list',
        children: [
            {
                key: 'addressbook.invoices.details',
                type: 'placeholder',
                showInNavigation: false,
                children: [
                    {
                        key: 'addressbook.invoices.details.index',
                        type: 'route',
                        route: 'app.billing.invoices.details',
                        right: 'billing::invoice-view',
                        hideTabNav: true
                    }
                ]
            }
        ]
    },
    {
        key: 'addressbook.picklists.main',
        type: 'route',
        route: 'app.picklists.index',
        right: 'picklists::list',
        children: [
            {
                key: 'addressbook.picklists.details',
                type: 'placeholder',
                showInNavigation: false,
                children: [
                    {
                        key: 'addressbook.picklists.contacts',
                        type: 'route',
                        route: 'app.picklists.contacts.index',
                        right: 'picklists::list',
                        hideTabNav: true
                    },
                    {
                        key: 'addressbook.picklists.edit',
                        type: 'route',
                        route: 'app.picklists.contacts.edit-settings',
                        right: 'picklists::edit',
                        hideTabNav: true,
                        showInNavigation: false
                    }
                ]
            },
            {
                key: 'addressbook.picklists.create',
                type: 'route',
                route: 'app.picklists.create',
                right: 'picklists::create',
                showInNavigation: false
            }
        ]
    },
    {
        key: 'addressbook.categories',
        type: 'route',
        route: 'app.categories.index',
        right: 'addressbook_categories::list'
    },
    {
        key: 'addressbook.exports',
        type: 'route',
        route: 'app.mo-exports.index',
        right: 'exports::list'
    },
    {
        key: 'addressbook.shippings.main',
        type: 'route',
        route: 'app.shippings.index',
        right: 'shipping::list',
        children: [
            {
                key: 'addressbook.shippings.details',
                type: 'route',
                route: 'app.shippings.details',
                right: 'shipping::edit',
                showInNavigation: false,
                hideTabNav: true
            }
        ]
    },
    {
        key: 'addressbook.vouchers.main',
        type: 'placeholder',
        children: [
            {
                key: 'addressbook.vouchers.list',
                type: 'route',
                route: 'app.vouchers.main.index',
                right: 'vouchers::list',
                children: [
                    {
                        key: 'addressbook.vouchers.details',
                        type: 'route',
                        route: 'app.vouchers.main.details',
                        right: 'vouchers::view',
                        showInNavigation: false
                    },
                ]
            },
            {
                key: 'addressbook.vouchers.templates-list',
                type: 'route',
                route: 'app.vouchers.templates.index',
                right: 'vouchers::templates-list',
                children: [
                    {
                        key: 'addressbook.vouchers.templates-view',
                        type: 'route',
                        route: 'app.vouchers.templates.details',
                        right: 'vouchers::templates-view',
                        showInNavigation: false
                    },
                ]
            },
            {
                key: 'addressbook.vouchers.exports',
                type: 'route',
                route: 'app.exports.vouchers',
                right: 'exports::vouchers'
            },
            {
                key: 'addressbook.vouchers.scanner',
                type: 'route',
                route: 'app.vouchers.main.scanner',
                right: 'vouchers::scan-vouchers'
            }
        ]
    },
    {
        key: 'addressbook.pdf-tickets.main',
        type: 'route',
        route: 'app.tickets.templates.index',
        right: 'tickets::templates-list',
        children: [
            {
                key: 'addressbook.pdf-tickets.create',
                type: 'route',
                route: 'app.tickets.templates.create',
                right: 'tickets::templates-create',
                showInNavigation: false,
                hideTabNav: true
            },
            {
                key: 'addressbook.pdf-tickets.edit',
                type: 'route',
                route: 'app.tickets.templates.edit',
                right: 'tickets::templates-edit',
                showInNavigation: false,
                hideTabNav: true
            }
        ]
    },
    {
        key: 'addressbook.wallets.main',
        type: 'route',
        route: 'app.wallets.templates.index',
        right: 'passbooks::list',
        children: [
            {
                key: 'addressbook.wallets.details',
                type: 'route',
                route: 'app.wallets.templates.details',
                right: 'passbooks::edit',
                showInNavigation: false,
                hideTabNav: true
            }
        ]
    }
]



// WEBPACK FOOTER //
// ./src/app/modules/navigation/resources/second-level/addressbook.js